import { render, staticRenderFns } from "./CampaignNew.vue?vue&type=template&id=57ef5703&"
import script from "./CampaignNew.vue?vue&type=script&lang=js&"
export * from "./CampaignNew.vue?vue&type=script&lang=js&"
import style0 from "./CampaignNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports